import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Exported so mutations that change onboarding state (account creation,
// onboarding-link redirects) can invalidate this query after they run.
export const STRIPE_STATUS_QUERY_KEY = "stripeStatus";

export const useStripeStatus = ({ enabled = true } = {}) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [STRIPE_STATUS_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/stripe/status`);
      return response.data;
    },
    enabled: enabled && !!tenantVal,
  });
};
